export default __webpack_public_path__ + "images/a327ecd794154a8ea4de02c69000e048-nye_header_mobile.webp";